module.exports = __webpack_public_path__ + "img/studentMNG.aaaed0bf.svg";